module.exports = __webpack_public_path__ + "static/media/iep-ui-design06-thumb.9dbc4db1.png";